import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import CheckBoxHLPure from '../checkBoxHL/checkBoxHL.pure';
import moment from 'moment';
import ReactEcharts from "echarts-for-react";
import multiTooltip from './multi-tooltip';

const formatHour = (value) => {
  return moment(value, "HH").format("h A")
}

const formatTime = (value, periodType, startDate) => {
  if (periodType == 'day') return moment(value, "HH").format("hh:mm A")
  else if (periodType == 'month') {
    const month = moment(startDate).get('month')
    return moment(`${value}-${month + 1}`, "DD-MM").format("MMM DD")
  }
}

function TicketVolumeGraph(props) {
  const { data, prevData, tickFormat, tickLongFormat, periodType, startDate } = props;
  const { t } = useTranslation('clients-dashboard', { keyPrefix: 'reportsScreen' });
  const [showPrevPeriod, setShowPrevPeriod] = useState(false)

  const periodTitle = useMemo(() => {
    let periodTitle = 'duringYear'
    if (periodType === 'day') {
      periodTitle = 'duringDay'
    } else if (periodType === 'week') {
      periodTitle = 'duringWeek'
    } else if (periodType === 'month') {
      periodTitle = 'duringMonth'
    }
    return periodTitle
  }, [periodType])

  const option = useMemo(() => {
    const graphData = showPrevPeriod ? prevData : data
    if (!graphData) return;

    const ownBusiness = graphData.find(data => data.own_business)
    const otherBusinesses = graphData.find(data => !data.own_business)

    let formatAxisValueFn
    if (periodType === 'day' || periodType === 'month') {
      formatAxisValueFn = (value) => formatTime(value, periodType, startDate)
    } else {
      formatAxisValueFn = (value) => tickLongFormat[value]
    }

    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {},
      grid: {
        top: 36, right: 4, bottom: 24, left: 44
      },
      xAxis: {
        type: 'category',
        data: tickFormat,
        containLabel: true,
        axisLabel: {
          formatter: periodType === 'day' ? formatHour : undefined
        }
      },
      yAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      tooltip: {
        trigger: 'axis',
        confine: true,
        formatter: (params) => multiTooltip({
          params,
          formatAxisValueFn,
          formatByIndex: true,
          formatFn: (value) => value.toFixed(2)
        })
      },
      series: [
        {
          name: t("myBusiness"),
          type: 'bar',
          data: ownBusiness?.data || [],
          itemStyle: { color: "#00a4e0" }
        },
        {
          name: t("otherBusinesses"),
          type: 'bar',
          data: otherBusinesses?.data || [],
          itemStyle: { color: "#69B75C" }
        }
      ],
      dataZoom: [
        {
          type: 'inside',
          orient: 'horizontal',
          start: 0,
          end: 100,
          minSpan: 10,
        },
        {
          type: 'slider',
          show: false,
        }
      ],
    };

    return option;
  }, [data, prevData, periodType, showPrevPeriod])

  return (
    <div className="dashboardView-card rasd-month" >
      <div className='rasd-month-heading'>
        <p className="dashboardView-card-title">{t("ticketVolume")} {t(periodTitle)}</p>
        <CheckBoxHLPure
          labelCheckBox={t("previousPeriod")}
          valueCheckBox={showPrevPeriod}
          checkedState={showPrevPeriod}
          onChangeHandler={(e) => setShowPrevPeriod(e.target.checked)}
        />
      </div>

      {
        option
          ? <ReactEcharts option={option} />
          : <p>N/D</p>
      }
    </div>
  )
}

export default TicketVolumeGraph